import React, { useRef } from "react";

import { Card } from "antd";

import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";

import Button from "Components/UI/Button/Button";
import Container from "Components/UI/Container";

import s from "./qr.module.scss";

export class QrPage extends React.PureComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    const { date, vin, make, model, year, appointmentId, stockId, actions } = this.props.info;

    // eslint-disable-next-line consistent-return, array-callback-return
    const linkItem = actions.filter((item, index) => {
      if (item.ctaType === "QR_CODE") {
        return item.params.link;
      }
    });

    const { link } = linkItem[0].params;

    return (
      <Card className={s.card}>
        <div className={s.infoWrapper}>
          <div className={s.infoBlock}>
            <h1>App ID: {appointmentId}</h1>
            <h1>VIN: {vin}</h1>
            <h1>
              {make} | {model} | {year}
            </h1>
          </div>
          {/* <div className={s.logo}>
                        <img src={Logo} alt="Logo" />
                        <h1 className={s.date}>{date}</h1>
                    </div> */}
        </div>
        <div className="flex">
          <QRCode size={600} value={link} />
        </div>
        <h1 className={s.stockId}>{stockId}</h1>
      </Card>
    );
  }
}

function PrintWrapper(props) {
  const componentRef = useRef();

  return (
    <Container>
      <div className={s.qrpage}>
        <Button onClick={props.closePage} className={s.button}>
          ← Back
        </Button>
        <ReactToPrint
          trigger={() => <Button className={s.button}>Print</Button>}
          content={() => componentRef.current}
        />
        <QrPage ref={componentRef} info={props.info} />
      </div>
    </Container>
  );
}

export default PrintWrapper;
